/* eslint max-len: ["error", { "code": 120, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Info from 'material-ui/svg-icons/action/info';
import {red300} from 'material-ui/styles/colors';

const ErrorConnection = ({locale}) => (
    <div style={{padding: '25px'}}>
        <Info style={{color: red300, display: 'block', margin: '0 auto', width: '100px', height: '100px'}}/>
        <h1 className="article-title-font" style={{textAlign: 'center'}}>{locale.offlineTitle}</h1>
        <p style={{textAlign: 'center'}}>{locale.offline}</p>
    </div>
);

ErrorConnection.propTypes = {
    locale: PropTypes.object,
};

const mapStateToProps = (state) => ({
    locale: state.locale.locale,
});

export default connect(
    mapStateToProps
)(ErrorConnection);



// WEBPACK FOOTER //
// ./src/components/ErrorConnection.js